<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 7.375C11.625 7.375 10.125 5.875 10.125 4C10.125 2.125 11.625 0.625 13.5 0.625C15.375 0.625 16.875 2.125 16.875 4C16.875 5.875 15.375 7.375 13.5 7.375ZM13.5 2.25C12.625 2.25 11.75 3 11.75 4C11.75 5 12.5 5.75 13.5 5.75C14.375 5.75 15.25 5 15.25 4C15.25 3 14.375 2.25 13.5 2.25Z"
      fill="#3A3A3A"
    />
    <path
      d="M8.25008 16.625C7.75008 16.625 7.25008 16.5 6.75008 16.375C5.37508 16 4.25008 15 3.62508 13.625C3.12508 12.25 3.12508 10.625 3.87508 9.25C4.12508 8.75 4.37508 8.125 4.37508 7.75C4.37508 7 4.00008 6.375 3.75008 6C3.50008 5.5 3.00008 4.75 3.62508 4.125C3.75008 4 4.00008 3.875 4.25008 3.875H12.5001C12.7501 3.875 12.8751 4 13.1251 4.125C13.7501 4.75 13.2501 5.5 13.0001 6C12.7501 6.5 12.3751 7 12.3751 7.75C12.3751 8.125 12.5001 8.625 12.8751 9.25C13.6251 10.625 13.6251 12.25 13.0001 13.625C12.3751 15 11.2501 16 9.87508 16.375C9.25008 16.5 8.75008 16.625 8.25008 16.625ZM5.25008 5.5C5.50008 6 5.87508 6.75 5.87508 7.75C5.87508 8.375 5.62508 9.25 5.25008 10C4.75008 11 4.75008 12 5.12508 13C5.50008 13.875 6.25008 14.5 7.12508 14.75C7.75008 14.875 8.50008 14.875 9.12508 14.75C10.0001 14.5 10.7501 13.875 11.1251 13C11.7501 12 11.6251 11 11.2501 10C10.7501 9.25 10.6251 8.5 10.6251 7.75C10.6251 6.75 11.0001 6 11.2501 5.5H5.25008Z"
      fill="#3A3A3A"
    />
    <path
      d="M8.25 19C7.75 19 7.375 18.625 7.375 18.125V15.75C7.375 15.25 7.75 14.875 8.25 14.875C8.75 14.875 9.125 15.25 9.125 15.75V18.125C9.125 18.625 8.75 19 8.25 19Z"
      fill="#3A3A3A"
    />
    <path
      d="M10.875 19.375H5.625C5.125 19.375 4.75 19 4.75 18.5C4.75 18 5.125 17.625 5.625 17.625H10.875C11.375 17.625 11.75 18 11.75 18.5C11.75 19 11.375 19.375 10.875 19.375ZM12.375 12.375H4.125C3.75 12.375 3.375 12 3.375 11.5C3.375 11 3.75 10.625 4.25 10.625H12.5C13 10.625 13.375 11 13.375 11.5C13.25 12 12.875 12.375 12.375 12.375Z"
      fill="#3A3A3A"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'DrinkIcon',
} as DefineComponent
</script>
